import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private router = inject(Router);

  /**
   * Forza il redirect alla pagina di login con fallback
   */
  redirectToLogin(): void {
    // Prova prima con il router di Angular
    try {
      this.router.navigate(['/auth/login'], { replaceUrl: true });
    } catch (error) {
      // Fallback: usa window.location se il router fallisce
      this.forceRedirectToLogin();
    }
  }

  /**
   * Fallback per il redirect usando window.location
   */
  private forceRedirectToLogin(): void {
    try {
      window.location.href = '/auth/login';
    } catch (error) {
      // Ultimo fallback: ricarica la pagina
      window.location.reload();
    }
  }

  /**
   * Verifica se siamo già nella pagina di login
   */
  isOnLoginPage(): boolean {
    return window.location.pathname === '/auth/login';
  }

  /**
   * Redirect sicuro che evita loop infiniti
   */
  safeRedirectToLogin(): void {
    if (!this.isOnLoginPage()) {
      this.redirectToLogin();
    }
  }
}
